import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private config: any;

    constructor(private readonly http: HttpClient,
        private readonly router: Router) { }

    async loadConfig(): Promise<void> {
        this.config = await firstValueFrom(this.http.get('/assets/config.json'));
    }

    getConfig(): any {
        return this.config;
    }

    get apiUrl(): string {
        if (!this.config && !globalThis.location.href.includes('login')) {
            globalThis.location.reload()
        }
        const href = globalThis.location.origin;
        switch (true) {
            case href.includes('localhost'):
                return this.config.hostname_port_be_local || '';
            case href.includes('pre'):
                return this.config.hostname_port_be_pre || '';
            case href.includes('test'):
                return this.config.hostname_port_be_test || '';
            case href.includes('https://tarifa.uoc.edu'):
                return this.config.hostname_port_be_pro || '';
            default:
                return this.config.hostname_port_be_local || '';
        }
    }

    get apiUrlFront(): string {
        const href = globalThis.location.origin;
        switch (true) {
            case href.includes('localhost'):
                return this.config.hostname_port_fe_local;
            case href.includes('pre'):
                return this.config.hostname_port_fe_pre;
            case href.includes('test'):
                return this.config.hostname_port_fe_test;
            case href.includes('https://tarifa.uoc.edu'):
                return this.config?.hostname_port_fe_pro;
            default:
                return this.config.hostname_port_fe_local;
        }
    }

    getUrlFront(): string {
        return this.config?.hostname_port_fe_local
    }

    get featureFlag(): boolean {
        return this.config?.featureFlag;
    }
}